var _ellipse, _ellipse2, _ellipse3, _path, _path2, _circle, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5238,
    cy: 16.619,
    rx: 14.4762,
    ry: 14.4762,
    fill: "#AB6A18"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4762,
    cy: 15.4762,
    rx: 14.4762,
    ry: 14.4762,
    fill: "#AB6A18"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 18,
    rx: 10.3333,
    ry: 10.3333,
    fill: "#E69B0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4762 29.9524C22.4712 29.9524 28.9524 23.4712 28.9524 15.4762C28.9524 7.48121 22.4712 1 14.4762 1C6.48121 1 0 7.48121 0 15.4762C0 23.4712 6.48121 29.9524 14.4762 29.9524ZM14.3333 25.6667C20.0403 25.6667 24.6667 21.0403 24.6667 15.3333C24.6667 9.62639 20.0403 5 14.3333 5C8.62639 5 4 9.62639 4 15.3333C4 21.0403 8.62639 25.6667 14.3333 25.6667Z",
    fill: "#FFC11A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.162975 17.6556C0.0556429 16.9448 0 16.217 0 15.4762C0 7.48121 6.48121 1 14.4762 1C18.7046 1 22.5095 2.81288 25.1562 5.70378C24.5805 7.11797 23.852 8.45367 22.9913 9.6904C21.1469 6.8663 17.958 5 14.3333 5C8.62639 5 4 9.62639 4 15.3333C4 16.4237 4.1689 17.4747 4.48196 18.4615C2.99216 18.3459 1.54687 18.0717 0.162975 17.6556Z",
    fill: "#FFE367"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00004,
    cy: 4.00004,
    r: 1.66667,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 15L14.8794 5.35997L22.0001 8.6666L18.2127 14.0266L23.546 17.0266L13.6668 25.6666L11.3335 25.3333L16.3334 17.6666L11.0001 15Z",
    fill: "#AB6A18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 14.6666L12.6668 3.99999L20.6188 5.00693L16.0001 12.6666L21.3334 15.6666L11.3334 25.3333L14.2728 17.2708L8.33341 14.6666Z",
    fill: "#FFE367"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.a652312b5bfa977a4876cb44803d88ec.svg";
export { ForwardRef as ReactComponent };